// future location of testing for router.
export var __nothing__: any /** TODO #9100 */;
